import { cn } from '@/lib/cn';

interface SpinnerProps {
  className?: string;
  /** Accessible label. Omit when the spinner sits inside a button that already says what is happening. */
  label?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const sizes = { xs: 'h-3 w-3', sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-8 w-8' } as const;

export function Spinner({ className, label, size = 'sm' }: SpinnerProps) {
  return (
    <span role={label ? 'status' : undefined} aria-label={label} className="inline-flex">
      <svg className={cn('animate-spin', sizes[size], className)} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
    </span>
  );
}
